(function () {
  "use strict";

  class ConvxMenuSlider extends HTMLElement {
    constructor() {
      super();
      this.flickityInstance = null;
      this.align = this.dataset.optionPosition;
      this._boundResizeHandler = this.updateFlickity.bind(this);
    }

initFlickity() {
  return new Promise((resolve) => {
    let tries = 0;
    const attempt = () => {
      if (this.offsetWidth === 0) {
        if (++tries > 60) { resolve(false); return; }
        setTimeout(attempt, 50);
        return;
      }
      if (this.flickityInstance) this.flickityInstance.destroy();
      this.flickityInstance = new Flickity(this, this.getFlickityOptions());
      resolve(true);
    };
    attempt();
  });
}

async connectedCallback() {
  const ok = await this.initFlickity();
  if (!ok) return;

  window.addEventListener("resize", this._boundResizeHandler);

  imagesLoaded(this, () => {
    if (!this.flickityInstance) return;
    void this.offsetHeight;
    this.flickityInstance.reloadCells();
    this.setUniformSlideHeights();
    this.flickityInstance.select(0);
  });
}


    disconnectedCallback() {
      window.removeEventListener("resize", this._boundResizeHandler);
      if (this.flickityInstance) {
        this.flickityInstance.destroy();
      }
    }

    getFlickityOptions() {
      const cellAlign = this.align || "center";
      return window.innerWidth < 768
        ? {
            cellAlign: "left",
            contain: true,
            // groupCells: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            freeScroll: true,
            percentPosition: true,
            wrapAround: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            lazyLoad: true,
          }
        : {
            cellAlign: "left",
            contain: true,
            // groupCells: true,
            draggable: true,
            prevNextButtons: true,
            pageDots: false,
            freeScroll: true,
            percentPosition: true,
            wrapAround: false,
            imagesLoaded: true,
            adaptiveHeight: true,
            lazyLoad: true,
          };
    }

    updateFlickity() {
      this.initFlickity();
    }

    setUniformSlideHeights() {
      // Wait until Flickity is ready and slides exist
      const slides = this.querySelectorAll(".flickity-slider > *");
      if (!slides.length) return;

      // Reset any inline height first
      slides.forEach((slide) => (slide.style.height = ""));

      // Find tallest slide
      let maxHeight = 0;
      slides.forEach((slide) => {
        const h = slide.offsetHeight;
        if (h > maxHeight) maxHeight = h;
      });

      // Set all slides to tallest height
      slides.forEach((slide) => {
        slide.style.height = maxHeight + "px";
      });

      if (this.flickityInstance) {
        this.flickityInstance.resize();
        this.flickityInstance.reloadCells();
      }
    }
  }

  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    customElements.define("convx-menu-slider", ConvxMenuSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();
